<template>
  <!-- <div :style="{ 'display': step === 1 ? 'none' : 'block' }" :key="String(step)"> -->
  <div class="max-width">
    <v-card-title class="justify-center mb-2">{{
      $t("signin-title")
    }}</v-card-title>
    <v-form v-model="valid" ref="form" class="text-center">
      <EmailField @setFormValue="email = $event" />
      <EyePassword @setFormValue="password = $event" />
      <v-row align="center" justify="center">
        <v-btn
          @click="submit"
          :loading="$store.state.loading"
          color="indigo accent-4"
          min-width="280"
          dark
          rounded
          large
          >{{ $t("signin-button") }}</v-btn
        >
        <v-btn
          x-small
          text
          color="indigo accent-4"
          class="mt-4"
          @click="$store.dispatch('authentication/toStep', 'recover')"
          >{{ $t("forgot-password") }}</v-btn
        >
      </v-row>
    </v-form>
    <ServerError />
    <div class="text-center mt-11 pt-0">
      <span class="caption">{{ $t("dont-have-an-account") }}</span
      >&nbsp;
      <!-- <v-btn
        small
        rounded
        outlined
        color="indigo accent-4"
        @click="$store.dispatch('authentication/toStep', 'registration')"
        >{{ $t("create-account-button") }}</v-btn
      > -->
    </div>
  </div>
</template>

<script>
import EmailField from "./EmailField";
import EyePassword from "./EyePassword";
import ServerError from "./ServerError";

export default {
  name: "Signin",
  components: { EmailField, EyePassword, ServerError },
  data: (vm) => ({
    valid: true,
    email: "",
    password: "",
  }),
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return null;
      this.$store.dispatch("authentication/signin", {
        email: this.email,
        password: this.password,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.max-width {
  max-width: 360px;
  margin: 0 auto;
}
</style>
